export function numberedCopyDefaults(space = {}) {
  const label = String(space.label || '').trim();
  const match = label.match(/^(.*?)(\d+)$/);
  return {
    count: '10',
    prefix: match ? match[1] : (label || 'Space '),
    start: match ? String(Number(match[2]) + 1) : '1',
    direction: 'right',
  };
}

export function uniqueMooringMapLabel(spaces = [], markerType = 'space') {
  const base = markerType === 'label' ? 'Label' : 'Space';
  const labels = new Set((Array.isArray(spaces) ? spaces : []).map((space) => String(space?.label || '').trim().toLowerCase()));
  let number = 1;
  while (labels.has(`${base} ${number}`.toLowerCase())) number += 1;
  return `${base} ${number}`;
}

export function directionalCopyLayout({ sourceVisual = {}, count = 0, direction = 'right', canvas = {} } = {}) {
  const amount = Math.max(0, Number(count) || 0);
  const snap = Math.max(1, Number(canvas.snap) || 24);
  const width = Math.max(snap, Number(sourceVisual.width) || snap);
  const height = Math.max(snap, Number(sourceVisual.height) || snap);
  const x = Math.max(0, Number(sourceVisual.x) || 0);
  const y = Math.max(0, Number(sourceVisual.y) || 0);
  const horizontal = direction === 'left' || direction === 'right';
  const sign = direction === 'left' || direction === 'up' ? -1 : 1;
  const step = (horizontal ? width : height) + snap;
  const minimumX = horizontal ? x + sign * amount * step : x;
  const minimumY = horizontal ? y : y + sign * amount * step;
  const shiftX = Math.max(0, -minimumX);
  const shiftY = Math.max(0, -minimumY);
  const shiftedSource = { ...sourceVisual, x: x + shiftX, y: y + shiftY, width, height };
  const visuals = Array.from({ length: amount }, (_, index) => {
    const offset = (index + 1) * step * sign;
    return {
      ...shiftedSource,
      x: shiftedSource.x + (horizontal ? offset : 0),
      y: shiftedSource.y + (horizontal ? 0 : offset),
    };
  });
  const right = Math.max(shiftedSource.x + width, ...visuals.map((visual) => visual.x + visual.width));
  const bottom = Math.max(shiftedSource.y + height, ...visuals.map((visual) => visual.y + visual.height));
  return {
    shiftX,
    shiftY,
    shiftedSource,
    visuals,
    canvas: {
      ...canvas,
      snap,
      width: Math.max(Number(canvas.width) || 0, (Number(canvas.width) || 0) + shiftX, right + snap),
      height: Math.max(Number(canvas.height) || 0, (Number(canvas.height) || 0) + shiftY, bottom + snap),
    },
  };
}

export function copyableMooringSpaceFields(space = {}) {
  return {
    status: 'vacant',
    maxLength: space.maxLength ?? null,
    maxBeam: space.maxBeam ?? null,
    maxDraft: space.maxDraft ?? null,
    vesselTypes: Array.isArray(space.vesselTypes) ? space.vesselTypes : [],
    clubBoatId: '',
    clubBoatLabel: '',
    boltOnId: '',
    mooringPrice: space.mooringPrice || {},
    notes: space.notes || '',
  };
}

export function marqueeRect(start = {}, end = {}) {
  const left = Math.min(Number(start.x || 0), Number(end.x || 0));
  const top = Math.min(Number(start.y || 0), Number(end.y || 0));
  return {
    left,
    top,
    width: Math.abs(Number(end.x || 0) - Number(start.x || 0)),
    height: Math.abs(Number(end.y || 0) - Number(start.y || 0)),
    right: Math.max(Number(start.x || 0), Number(end.x || 0)),
    bottom: Math.max(Number(start.y || 0), Number(end.y || 0)),
  };
}

export function rectsIntersect(left = {}, right = {}) {
  return left.left <= right.right
    && left.right >= right.left
    && left.top <= right.bottom
    && left.bottom >= right.top;
}

export function selectedSpaceDeleteBlockers({ selectedIds = [], spaces = [], allocations = [], boats = [], waitlist = [], maintenance = [] } = {}) {
  const ids = new Set(selectedIds);
  const linked = (entry = {}) => ['spaceId', 'offeredSpaceId', 'allocatedSpaceId', 'homeMooringSpaceId', 'currentMooringSpaceId']
    .some((field) => ids.has(String(entry[field] || '').trim()));
  return {
    allocations: allocations.filter(linked).length,
    clubBoats: boats.filter((boat) => linked(boat) || ids.has(String(spaces.find((space) => space.clubBoatId === boat.id)?.id || ''))).length,
    waitlist: waitlist.filter(linked).length,
    maintenance: maintenance.filter(linked).length,
  };
}
